import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './Leaderboard.css'; // ✅ Import styles

const API_BASE_URL = 'https://wholeness-forward.onrender.com/api';

const CompanyLeaderboard = () => {
    const [leaderboard, setLeaderboard] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [timeframe, setTimeframe] = useState('all-time'); // ✅ Filter by timeframe
    const [search, setSearch] = useState(''); // ✅ Search by company name

    // ✅ Fetch Leaderboard Data with Timeframe
    useEffect(() => {
        const fetchLeaderboard = async () => {
            try {
                console.log(`📡 Fetching company leaderboard data (Timeframe: ${timeframe})...`);
                const response = await axios.get(`${API_BASE_URL}/leaderboard/company-leaderboard?timeframe=${timeframe}`);
                setLeaderboard(response.data);
            } catch (err) {
                setError('Error fetching leaderboard');
                console.error('❌ Error fetching leaderboard:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchLeaderboard();
    }, [timeframe]);

    // ✅ Search Filtering
    const filteredLeaderboard = leaderboard.filter(entry => 
        entry.company?.name?.toLowerCase().includes(search.toLowerCase())
    );

    if (loading) return <div className="loading">Loading leaderboard...</div>;
    if (error) return <div className="error-message">{error}</div>;

    return (
        <div className="leaderboard-container">
            <h1 className="leaderboard-title">🏢 Company Leaderboard</h1>

            {/* ✅ Timeframe Filters */}
            <div className="timeframe-buttons">
                <button className={timeframe === 'all-time' ? 'active' : ''} onClick={() => setTimeframe('all-time')}>All Time</button>
                <button className={timeframe === 'week' ? 'active' : ''} onClick={() => setTimeframe('week')}>This Week</button>
                <button className={timeframe === 'month' ? 'active' : ''} onClick={() => setTimeframe('month')}>This Month</button>
                <button className={timeframe === 'year' ? 'active' : ''} onClick={() => setTimeframe('year')}>This Year</button>
            </div>

            {/* ✅ Search by Company Name */}
            <div className="search-container">
                <input
                    type="text"
                    placeholder="Search by company name..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="leaderboard-search"
                />
            </div>

            {/* ✅ Leaderboard Table */}
            <table className="leaderboard-table">
                <thead>
                    <tr>
                        <th>Rank</th>
                        <th>Company Name</th>
                        <th>Total Weight Lost (lbs)</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredLeaderboard.length === 0 ? (
                        <tr><td colSpan="3" className="no-data">No data available</td></tr>
                    ) : (
                        filteredLeaderboard.map((entry, index) => (
                            <tr key={entry._id}>
                                <td>{index + 1}</td>
                                <td>{entry.company?.name}</td>
                                <td>{(entry.totalWeightLost || 0).toFixed(2)}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            {/* 🔙 Back to Leaderboard */}
            <Link to="/leaderboard" className="leaderboard-link">← Back to Main Leaderboard</Link>
        </div>
    );
};

export default CompanyLeaderboard;
